import { SvgIcon } from '@mui/material';

interface DriverVolumeIconProps {
  style?: React.CSSProperties;
}

export default function DriverVolumeIcon({ style = {}, ...props }: DriverVolumeIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 11.52 12.06" style={{ height: `14px`, ...style }}>
      <g>
        <path
          fill="none"
          d="M1.55,7.62c0,2.32,1.88,4.21,4.21,4.21s4.21-1.88,4.21-4.21C9.97,4.44,5.76,.21,5.76,.21,5.76,.21,1.55,4.44,1.55,7.62Z"
        />
        <path
          fill="#717679"
          fillRule="evenodd"
          d="M5.76,10.78c1.73,0,3.14-1.42,3.14-3.17S7.04,3.25,5.76,1.78c-1.28,1.47-3.14,4.02-3.14,5.84s1.41,3.17,3.14,3.17m0,1.07c-2.32,0-4.21-1.9-4.21-4.23C1.55,4.44,5.76,.21,5.76,.21c0,0,4.21,4.23,4.21,7.41,0,2.34-1.88,4.23-4.21,4.23Z"
        />
      </g>
    </SvgIcon>
  );
}
